export const REQUIRED_FIELDS_MESSAGE = 'Please fill all required fields';

export const getValidationState = <T extends string>(
  errors: Record<T, boolean>,
): { fieldErrors: Record<T, boolean>; hasErrors: boolean } => ({
  fieldErrors: errors,
  hasErrors: Object.values(errors).some(Boolean),
});
